import React from "react";
import {
    AdditionalChecklistBlockData,
    DEFAULT_ADDITIONAL_CHECKLIST_BLOCK_DATA,
} from "models/interfaces/additional-block-data/additional-checklist-block-data";
import { ReadonlyPageBlockProps } from "organisms/page-blocks/readonly-page-block/readonly-page-block";
import { ReadonlyPageBlockContent } from "organisms/page-blocks/readonly-page-block/readonly-page-block-content";
import { useChecklistBlockChecklistItems } from "utilities/hooks/domain/block-configurations/use-checklist-block-checklist-items";

interface ReadonlyChecklistPageBlockProps extends ReadonlyPageBlockProps {
    recipientGuid?: string;
    sharedPageGuid?: string;
}

export const ReadonlyChecklistPageBlock: React.FC<
    ReadonlyChecklistPageBlockProps
> = (props: ReadonlyChecklistPageBlockProps): JSX.Element => {
    const { items } = useChecklistBlockChecklistItems(
        props.block.configuration
    );
    const additionalBlockData: AdditionalChecklistBlockData = {
        ...DEFAULT_ADDITIONAL_CHECKLIST_BLOCK_DATA,
        items: items,
    };

    return (
        <ReadonlyPageBlockContent
            {...props}
            additionalBlockData={additionalBlockData}
        />
    );
};
